// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".fb75bdaad32735c13e15c4a273160c93ef78e347.chunk.bundle.js";
};